import { createIcon } from '../createIcon';

export const ChevronUpIcon = createIcon({
  viewBox: '0 0 20 12',
  d:
    'M18.2286 12L9.99728 3.62148L1.76862 11.9973L0 10.1971L10 0L20 10.1971L18.2286 12Z',
});

export const ChevronDownIcon = createIcon({
  viewBox: '0 0 20 12',
  d:
    'M18.2286 0L9.99728 8.37852L1.76862 0.00268367L0 1.80293L10 12L20 1.80293L18.2286 0Z',
});

export const ChevronLeftIcon = createIcon({
  viewBox: '0 0 12 20',
  d:
    'M12 1.77141L3.62148 10.0027L11.9973 18.2314L10.1971 20L0 10L10.1971 0L12 1.77141Z',
});

export const ChevronRightIcon = createIcon({
  viewBox: '0 0 12 20',
  d:
    'M0 1.77141L8.37852 10.0027L0.00268364 18.2314L1.80293 20L12 10L1.80293 0L0 1.77141Z',
});
